// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"306":"component---cache-caches-gatsby-plugin-offline-app-shell-js","678":"component---src-pages-index-js"}[chunkId] + "-" + {"306":"e5118b425b80304ff7bd","678":"a142073228d4f365c2d0"}[chunkId] + ".js";
};